/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

import { registerPlugins } from '@/plugins'
import App from './App.vue'
import { createApp } from 'vue'
import router from './router'
import * as Sentry from '@sentry/vue'
import 'vue-sonner/style.css'

const app = createApp(App)

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: import.meta.env.VITE_SENTRY_TRACE_SAMPLE_RATE || 1, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [import.meta.env.VITE_API_URL],
  // Session Replay
  replaysSessionSampleRate: import.meta.env.VITE_SENTRY_SESSION_SAMPLE_RATE || 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: import.meta.env.VITE_SENTRY_ONERROR_SAMPLE_RATE || 1, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  // Ignore specific errors that are handled gracefully
  beforeSend: (event, hint) => {
    const error = hint.originalException
    // Ignore dynamic import failures that are handled with reload
    if (error?.message?.includes('Failed to fetch dynamically imported module')) return null
    return event
  },
})

registerPlugins(app)

app.mount('#app')
